'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CameraIcon = require('./CameraIcon');

var _CameraIcon2 = _interopRequireDefault(_CameraIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CameraIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CameraIcon/index.js
// module id = 163
// module chunks = 11